import { StyleSheet } from 'react-native';
import { CornerRadius } from 'src/theme-v2/corner-radius';

export const styles = StyleSheet.create({
  button: {
    borderWidth: 2,
    borderColor: 'transparent',
    borderRadius: CornerRadius.Full,
  },
});
